import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > * + *': {
            marginLeft: theme.spacing(2),
        },
        textAlign: 'center',
        width: '100%'
    },
    progressContiner: {
        margin: '15px auto 0px auto',
        display: 'block',
        width: '100%'
    },
}));

const Loader = ({ text }) => {
    const classes = useStyles();
    return (

        <div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item md={12} xs={12}>
                    <div className={classes.progressContiner}>
                        <CircularProgress />
                    </div>
                    <p>{text}</p>
                </Grid>
            </Grid>
        </div>

    )
}

Loader.propTypes = {
    text: PropTypes.string.isRequired,
}

export default Loader
